import { aziendeFixture } from "./fixtures/aziende";

export type AziendaStato = "Attiva" | "In attesa";

export type Azienda = {
  id: string;
  nome: string;
  settore: string;
  referente: string;
  email: string;
  stato: AziendaStato;
  pratiche: number;
  documenti: number;
  ultimaAttivita: string;
};

export type NuovaAziendaInput = Pick<Azienda, "nome" | "settore" | "referente" | "email">;

const delay = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));
let aziendeState = aziendeFixture.map((azienda) => ({ ...azienda }));

export async function listAziende(): Promise<Azienda[]> {
  await delay(260);
  return aziendeState.map((azienda) => ({ ...azienda }));
}

export async function getAzienda(id: string): Promise<Azienda | undefined> {
  await delay(180);
  const azienda = aziendeState.find((item) => item.id === id);
  return azienda ? { ...azienda } : undefined;
}

export async function createAzienda(input: NuovaAziendaInput): Promise<Azienda> {
  await delay(320);
  const nome = input.nome.trim();
  const settore = input.settore.trim();
  const referente = input.referente.trim();
  const email = input.email.trim();
  if (!nome || !settore || !referente || !email) throw new Error("Dati azienda incompleti");
  if (nome.toLowerCase().includes("errore")) throw new Error("Creazione azienda non disponibile");
  const azienda: Azienda = {
    id: `azienda-${Date.now()}`,
    nome,
    settore,
    referente,
    email,
    stato: "Attiva",
    pratiche: 0,
    documenti: 0,
    ultimaAttivita: "Azienda aggiunta oggi",
  };
  aziendeState = [azienda, ...aziendeState];
  return { ...azienda };
}
